import { jsx as _jsx } from "react/jsx-runtime";
import { ListBox } from '@yonderland/andes-react';
export const MenuSearchResult = ({ testId, itemProps, variant, url, state, children }) => (_jsx("div", Object.assign({}, itemProps, { children: _jsx(ListBox.Item, { paddingInline: "0", testId: testId, href: url, tabIndex: -1, state: state, variant: variant, children: children }) })));
